
import * as React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import { IOfferListItem, IOfferType } from "../../../interfaces/IOffer";
import { Api } from "../../../lib/Api";
import EditOffer from "./EditOffer";
import OfferRow from "./OfferRow";
import $ from "jquery";
import ModifyOfferDialog from "./ModifyOfferDialog";
import DateTool from "../../../../avernus/datetool/source/DateTool";
import CreateOffer from "./CreateOffer";
import CloseToday from "../CloseTodayModal"
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IOfferListProps {
    setUrl          : any
    restaurantId    : number
    activeOfferMode?: boolean
}

interface IOfferTypeWithNumber{
    id   : number
    name : string
    max  : number
}

interface IOfferListState {
    items                        : Array<IOfferListItem>
    openOfferId                  : number
    openModifyDialogOfferId      : number
    version                      : number
    offerTypeOptions             : Array<IOfferTypeWithNumber>
    currentOfferTypeId           : number
    activeOfferMode              : boolean
    openCloseRestaurantTodayModal: boolean
    loading                      : boolean
    success                      : string
    error                        : string
    currentRestaurantIsOpen      : boolean

}

interface IGetListResult {
    items                  : Array<IOfferListItem>
    offerTypeOptions       : Array<IOfferTypeWithNumber>
    currentRestaurantIsOpen: boolean
}

export default class OfferList extends React.Component<IOfferListProps, IOfferListState>{

    private restaurantId:number;

  	constructor(props:IOfferListProps){
        super(props);
        this.state = {
            version                         : 0,
            success                         : null,
            error                           : null,
            items                           : null,
            openOfferId                     : null,
            openModifyDialogOfferId         : null,
            offerTypeOptions                : [],
            currentOfferTypeId              : 0,
            activeOfferMode                 : this.props.activeOfferMode !== undefined && this.props.activeOfferMode === true,
            openCloseRestaurantTodayModal   : false,
            loading                         : true,
            currentRestaurantIsOpen         : false
        };
        this.restaurantId = null;
        if ( this.props.restaurantId !== undefined ) {
            this.restaurantId = this.props.restaurantId;
        }
        this.init();
    }

    private init(){
        document.body.classList.remove('modal-open');
        if ( this.state.loading === false ) {
            this.setState({
                loading: true
            }, () =>{
                this.getData();
            });
        }else{
            this.getData();
        }
    }

    private getData():void{
        Api.call('/restaurants/offers/getListForTable', {
            restaurantId        : this.restaurantId,
            offerTypeId         : this.state.currentOfferTypeId,
            justIsActiveToday   : this.state.activeOfferMode
        }, (result:IGetListResult)=>{
            this.setState({
                items                     : result.items,
                offerTypeOptions          : result.offerTypeOptions,
                currentRestaurantIsOpen   : result.currentRestaurantIsOpen,
                version                   : (this.state.version + 1),
                loading                   : false,
                openCloseRestaurantTodayModal: false
            });
        });
    }

    private addNewOfferBtnClickHandler(evt): void {
        evt.preventDefault();
        if ( document.querySelector('#create_offer_modal') !== null ) {
            $('#create_offer_modal').modal({show:true});
        }
        this.setState({
            openModifyDialogOfferId: null,
            openOfferId: 0
        });
    }



    private editOfferBtnClickHandler(evt, id:number): void {
        evt.preventDefault();
        if ( document.querySelector('#edit_offer_modal') !== null ) {
            $('#edit_offer_modal').modal({show:true});
        }
        this.setState({
            openModifyDialogOfferId: null,
            openOfferId: id
        });
    }
    private openModifyDialogBtnClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.setState({
            openModifyDialogOfferId         : id,
            openCloseRestaurantTodayModal   : false
        });
    }

    private toggleDisadledDateBtnClickHandler(evt, id:number, name:string, isActiveToday:boolean): void {
        evt.preventDefault();
        $('#view_modal').modal('toggle');
        if ( document.querySelector('.modal-backdrop') !== null ) {
            $('.modal-backdrop').remove();
        }
        this.setState({
            openOfferId            : null,
            openModifyDialogOfferId: null,
            loading                : true
        }, () =>{
            if ( isActiveToday === true ) {
                Api.call('/restaurants/offers/toggleDisabledDate', {
                    id: id,
                    restaurantId: this.restaurantId
                }, (result)=>{
                    this.init(); // reload
                    if ( result.error !== null ) {
                        alert(result.error);
                    }
                });
            }else{
                Api.call('/restaurants/offers/toggleDisabledDate', {
                    id: id,
                    restaurantId: this.restaurantId
                }, (result)=>{
                    this.init(); // reload
                    if ( result.error !== null ) {
                        alert(result.error);
                    }
                });
            }
        });
    }

    private changOfferTYpeIdClickHandler(evt, offerTypeId:number): void {
        evt.preventDefault();
        $('#view_modal').modal('toggle');
        if ( document.querySelector('.modal-backdrop') !== null ) {
            $('.modal-backdrop').remove();
        }
        this.setState({
            items                  : null,
            openOfferId            : null,
            openModifyDialogOfferId: null,
            currentOfferTypeId     : offerTypeId
        }, ()=>{
             this.init(); // reload
        });
    }


    render() {
        let title = this.state.activeOfferMode===true?'Active services':'My services';

        if ( this.state.openModifyDialogOfferId !== null || this.state.openCloseRestaurantTodayModal === true ) {
            setTimeout(() => {
                if ( document.querySelector('#view_modal') !== null ) {
                    $('#view_modal').modal({show:true});
                }
                if ( document.querySelector('#close_restaurant_modal') !== null ) {
                    $('#close_restaurant_modal').modal({show:true});
                }
            }, 200);
        }
        return (
            <div id="restaurant_offerslist" className={ (this.state.activeOfferMode === false?'offermodeon':'') }>
                <Header
                    title = {title}
                    subTitle = {this.state.activeOfferMode === true ? (DateTool.getDate(null, 'en', true) + ', ' + DateTool.getDayName(null, 'en').toLowerCase()) : undefined}
                    setUrl={this.props.setUrl}
                />
                <div className="container content_section">
                    <div className={"h1_box"}>
                        <h1>{title}</h1>
                    </div>

                    {this.OfferListSection() }

                    {this.state.openOfferId !== null &&
                        <div role="dialog" className="modal fade" id="create_offer_modal">
                            <div className="modal-dialog modal-md" role="document">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <CreateOffer
                                            key={'offer_form_' + this.state.openOfferId}
                                            changed={(close) => {
                                                if (close === true) {
                                                    this.setState({
                                                        openOfferId: null
                                                    }, () => {
                                                        $('#create_offer_modal').modal('toggle');
                                                        if (document.querySelector('.modal-backdrop') !== null) {
                                                            $('.modal-backdrop').remove();
                                                        }
                                                        this.init();
                                                    });
                                                } else {
                                                    this.init();
                                                }
                                            }}
                                            restaurantId={this.restaurantId}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    { this.state.openModifyDialogOfferId !== null &&
                        <div role="dialog" className="modal fade" id="view_modal">
                            <div className="modal-dialog modal-md" role="document">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <ModifyOfferDialog
                                            key={this.state.openModifyDialogOfferId}
                                            id={this.state.openModifyDialogOfferId}
                                            restaurantId={this.props.restaurantId}
                                            modifyJustPortionMode={this.state.activeOfferMode}
                                            closed={ e => {
                                                this.setState({
                                                    openModifyDialogOfferId: null
                                                }, () =>{
                                                    $('#view_modal').modal('toggle');
                                                    if ( document.querySelector('.modal-backdrop') !== null ) {
                                                        $('.modal-backdrop').remove();
                                                    }
                                                    this.init();
                                                });
                                            } }

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <CloseToday
                        changed={ e => this.init() }
                        restaurantId={this.props.restaurantId}
                        openCloseRestaurantTodayModal={this.state.openCloseRestaurantTodayModal }
                        RestaurantIsOpen={this.state.currentRestaurantIsOpen}
                    />

                    <div className="col-sm-12">
                        { this.state.error !== null?<div className="alert alert-danger">
                                { this.state.error }
                        </div>:''}
                        { this.state.success !== null?<div className="alert alert-success">
                                { this.state.success }
                        </div>:''
                        }
                    </div>


                </div>
               <Footer setUrl={this.props.setUrl}/>
			</div>
        );
    }

    private OfferListSection() {
        return <section className="offer_list">
            {this.state.items === null || this.state.loading === true ? <div className="text-center">
                <LoaderComp show={true} />
            </div> : <>
                    {this.state.items.map((item, index) => {
                        return <OfferRow
                            key={index}
                            item={item}
                            editOfferBtnClickHandler={ (evt, id) =>{
                                this.editOfferBtnClickHandler(evt, id)
                            }}
                            openModifyDialogBtnClickHandler={ (evt, id) =>{
                                this.openModifyDialogBtnClickHandler(evt, id)
                            }}
                            toggleDisadledDateBtnClickHandler={ (evt, id, name, isActiveToday) =>{
                                this.toggleDisadledDateBtnClickHandler(evt, id, name, isActiveToday)
                            }}
                        />;
                    })}

                    <div className="row mt35">
                        <div className="col-12">
                            { this.state.activeOfferMode === true?
                                <>
                                    { this.state.currentRestaurantIsOpen === true?
                                        <button className="red_btn" id="add_close_for_today_btn" onClick={(e) => { this.setState({
                                            openCloseRestaurantTodayModal : true
                                        }) } }>
                                            Close today
                                        </button> :
                                        <button className="green_btns" id="reopen_restaurant_bottom_list_btn" onClick={(e) => { this.setState({
                                            openCloseRestaurantTodayModal : true
                                        }) } }>
                                            Reopen
                                        </button>
                                    }
                                </>
                                :
                                <>
                                    <button className="purple_btn" id="add_new_offer_btn" onClick={(e) => { this.addNewOfferBtnClickHandler(e); } }>
                                        New services
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                </>}
        </section>;
    }
}
